import React from "react";
import { Box,useMediaQuery , Tab, Tabs, Typography } from '@mui/material';

import CustomText, { textStyles } from "../../../../components/CustomText";
import profileperson from "../../../../assets/profileperson.png";
import company from "../../../../assets/company.png";
import back from "../../../../assets/back.svg";
import ActiveInactiveChart from "./ActiveDeatilsChart";
import { useTranslation } from "react-i18next";
import StatusDropdown from "../../../../components/StatusDropdown";
import dummy from "../../../../assets/dummy.png";
import WorkerAttendance from "./workerAttendance";
import WorkerTask from "./Wokertask";
import WorkerRequest from "./WorkerRequest";
import WorkerDocument from "./WorkerDocument";
import WorkerExpense from "./WorkerExpense";
import { useState ,useEffect} from "react";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../../components/BaseUrl.js";
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils";
import DetailsMapSection from "./DeatilsMapSection.js"
import { GoogleMap, Marker, Circle, InfoWindow } from "@react-google-maps/api";
import WorkerReimbursements from "./WorkerReimbursements.js";
import WorkerAbsence from "./WorkerAbsence.js";
import WorkerReports from "./WorkerReports.js";
const mapContainerStyle = { width: "100%", height: "100%" };
const workerLocationMarkerUrl =
  "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png";

const WorkerDetails = ({ worker, onBack ,
  refreshKey
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:768px)");
 const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;


    const [workerData, setWorkerData] = useState(null);  // State to store worker data
const [loading, setLoading] = useState(true);  // Loading state
  const [error, setError] = useState(null);  
  // Fetch worker details when component is mounted
  useEffect(() => {
    const fetchWorkerData = async () => {
      try {
        const response = await fetch(`${BASE_URL}/company-admins/workers/${worker.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${decryptedToken}`  // Pass the token here in the header
          }
        });
        const data = await response.json();
        console.log("worker details data", data)
        if (data.error) {
          throw new Error(data.message);
        }
console.log("workerdetaiol",data.data)
        setWorkerData(data.data);  // Set fetched data to state
        setLoading(false);  // Set loading to false after data is fetched
      } catch (err) {
        console.error("Error fetching worker data:", err);
        setError("Failed to load worker data.");
        setLoading(false);
      }
    };

    fetchWorkerData();
  }, [worker.id, decryptedToken,refreshKey]);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
const formatScheduleTime = (timeString) => {
  const localValue = convertUTCToLocalDateTime(timeString, {
    locale: "en-GB",
    formatOptions: { hour: "numeric", minute: "2-digit", hour12: true },
  });
  return localValue === "—" ? "--" : localValue;
};

const formatDailyHoursDisplay = (dailyHours) => {
  if (dailyHours === null || dailyHours === undefined || dailyHours === "" || dailyHours === "-") {
    return "--";
  }
  const hours = Number(dailyHours);
  if (Number.isNaN(hours)) return "--";

  const totalMinutes = Math.max(0, Math.round(hours * 60));
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;

  if (h > 0 && m > 0) return `${h}h ${m} min`;
  if (h > 0) return `${h}h`;
  return `${m}min`;
};

// Safe check for attendanceSettings.schedule and startTime/endTime
const startTime = workerData?.attendanceSettings?.schedule?.startTime;
const endTime = workerData?.attendanceSettings?.schedule?.endTime;

const formattedStartTime = formatScheduleTime(startTime);
const formattedEndTime = formatScheduleTime(endTime);
const [activeMapPopup, setActiveMapPopup] = useState(null);

const getBlueMarkerIcon = () => {
  if (!window.google?.maps) {
    return { url: workerLocationMarkerUrl };
  }

  return {
    url: workerLocationMarkerUrl,
    scaledSize: new window.google.maps.Size(25, 41),
    anchor: new window.google.maps.Point(12, 41),
  };
};

// Date-only formatter for fields that should not show time.
const formatDateOnly = (isoString) => {
  if (!isoString) return "--";

  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return "--";

  return date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};


  return (
    <>
      {/* Top Back Bar */}
      <Box
        sx={{
          border: "1px solid #E4E6EF",
          borderRadius: 2,
          px: 2,
          backgroundColor: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          minHeight: 55,
          ml: 1,
          mr: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            cursor: "pointer",
          }}
          onClick={onBack}
        >
          <img src={back} style={{ width: 30, height: 30 }} alt="back" />
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 500,
              fontSize: "14px",
              color: "#626F86",
            }}
          >
        {t("workerDetails.breadcrumb")}  {worker.name}
          </CustomText>
        </Box>
      </Box>

      {/* Main Layout */}
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: 2,
          mt: 2,
          px: 2,
        }}
      >
        {/* Left Column */}
        <Box
          sx={{
            width: isMobile ? "100%" : "50%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {/* Account Details */}
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              border: "1px solid #E4E6EF",
              p: 3,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 3,
                mt: 1,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
          {t("workerDetails.accountDetails")}
            </CustomText>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                mb: 2,
              }}
            >
       <img
    crossOrigin="anonymous"
    src={workerData?.profileImage || dummy}
    alt="profile"
    style={{ width: 120, height: 120, borderRadius: "50%", objectFit: "cover" }}
    onError={(e) => {
      e.currentTarget.src = dummy;
    }}
  />
            </Box>

            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 16,
                    fontWeight: 400,
                    color: "#5E5C5C",
                    textAlign: "left",
                  }}
                >
          {t("workerDetails.id")}{" "}
                </CustomText>
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 15,
                    fontWeight: 400,
                    color: "#172B4D",
                    textAlign: "left",
                  }}
                >
                  {workerData?.id}{" "}
                </CustomText>{" "}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 16,
                    fontWeight: 400,
                    color: "#5E5C5C",
                    textAlign: "left",
                  }}
                >
            {t("workerDetails.status")}
                </CustomText>
                   <Box sx={{ pointerEvents: "none" }}>
                                          <StatusDropdown currentStatus={workerData?.status||"--"} />
                                        </Box>

              </Box>


        <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 16,
                    fontWeight: 400,
                    color: "#5E5C5C",
                    textAlign: "left",
                  }}
                >
          {t("email")}{" "}
                </CustomText>
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 15,
                    fontWeight: 400,
                    color: "#172B4D",
                    textAlign: "left",
                  }}
                >
                  {workerData?.email}{" "}
                </CustomText>{" "}
              </Box>
        

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 16,
                    fontWeight: 400,
                    color: "#5E5C5C",
                    textAlign: "left",
                  }}
                >
             {t("workerDetails.name")}
                </CustomText>
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 15,
                    fontWeight: 400,
                    color: "#172B4D",
                    textAlign: "left",
                  }}
                >
                  {workerData?.fullName}{" "}
                </CustomText>{" "}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 16,
                    fontWeight: 400,
                    color: "#5E5C5C",
                    textAlign: "left",
                  }}
                >
            {t("workerDetails.phone")}
                </CustomText>
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 15,
                    fontWeight: 400,
                    color: "#172B4D",
                    textAlign: "left",
                  }}
                >
                  {workerData?.phone || "--"}
                </CustomText>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 16,
                    fontWeight: 400,
                    color: "#5E5C5C",
                    textAlign: "left",
                  }}
                >
               {t("workerDetails.dob")}
                </CustomText>
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 15,
                    fontWeight: 400,
                    color: "#172B4D",
                    textAlign: "left",
                  }}
                >
             {formatDateOnly(workerData?.dob)}{" "}
                </CustomText>{" "}
              </Box>

              {/* Worker Current Location Map */}
              {workerData?.latitude && workerData?.longitude && (
                <Box sx={{ mt: 3 }}>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 600,
                      color: "#003149",
                      mb: 1.5,
                      textAlign: "left",
                    }}
                  >
                    {t("workerDetails.currentLocation") || "Worker Current Location"}
                  </CustomText>
                  <Box
                    sx={{
                      height: 250,
                      borderRadius: "8px",
                      overflow: "hidden",
                      border: "1px solid #E4E6EF",
                      mt: 1,
                    }}
                  >
                    <GoogleMap
                      mapContainerStyle={mapContainerStyle}
                      center={{
                        lat: parseFloat(workerData.latitude),
                        lng: parseFloat(workerData.longitude),
                      }}
                      zoom={15}
                      options={{
                        fullscreenControl: false,
                        mapTypeControl: false,
                        streetViewControl: false,
                      }}
                    >
                      <Marker
                        position={{
                          lat: parseFloat(workerData.latitude),
                          lng: parseFloat(workerData.longitude),
                        }}
                        icon={getBlueMarkerIcon()}
                        onClick={() => setActiveMapPopup("current")}
                      />
                      {activeMapPopup === "current" && (
                        <InfoWindow
                          position={{
                            lat: parseFloat(workerData.latitude),
                            lng: parseFloat(workerData.longitude),
                          }}
                          onCloseClick={() => setActiveMapPopup(null)}
                        >
                          <Box sx={{ fontFamily: "Poppins, sans-serif" }}>
                            {workerData.fullName || "Worker Location"}
                          </Box>
                        </InfoWindow>
                      )}
                    </GoogleMap>
                  </Box>
                </Box>
              )}

              {/* Employment Details and General Details - Moved from Right Column */}
              <Box
                sx={{
                  backgroundColor: "#fff",
                  // borderRadius: 2,
                  // border: "1px solid #E4E6EF",
                  // p: 3,
                  mt: 2,
                }}
              >
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 18,
                    mb: 3,
                    mt: 1,
                    fontWeight: 600,
                    color: "#003149",
                    textAlign: "left",
                  }}
                >
                  {t("common.employmentDetails")}
                </CustomText>

                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 16,
                    mb: 3,
                    mt: 1,
                    fontWeight: 600,
                    color: "#003149",
                    textAlign: "left",
                  }}
                >
                  {t("common.generalDetails")}
                </CustomText>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("common.workerId")}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "left",
                    }}
                  >
                    {workerData?.id}
                  </CustomText>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("common.departmentName")}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "left",
                    }}
                  >
                    {workerData?.department?.name || "--"}
                  </CustomText>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("workerDetails.designation")}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "left",
                    }}
                  >
                    {workerData?.designation || workerData?.position || "--"}
                  </CustomText>
                </Box>

                {/* Document URL */}
                {workerData?.documentUrl && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <CustomText
                      sx={{
                        ...textStyles.h1,
                        fontSize: 16,
                        fontWeight: 400,
                        color: "#5E5C5C",
                        textAlign: "left",
                      }}
                    >
                      {t("nationalId.label") || "National ID"}
                    </CustomText>
                    <CustomText
                      component="a"
                      href={workerData.documentUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        ...textStyles.h1,
                        fontSize: 14,
                        fontWeight: 400,
                        color: "#1976d2",
                        textAlign: "left",
                        textDecoration: "underline",
                        cursor: "pointer",
                        "&:hover": {
                          color: "#115293",
                        },
                      }}
                    >
                      {t("workerDetails.viewDocument") || "View Document"}
                    </CustomText>
                  </Box>
                )}

                {/* <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("employeeId")}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "left",
                    }}
                  >
                    {workerData?.employeeId || "--"}
                  </CustomText>
                </Box> */}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("workerDetails.employmentType")}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "left",
                    }}
                  >
                    {workerData?.employeeType || "--"}
                  </CustomText>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("workerDetails.hireDate")}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "left",
                    }}
                  >
                     {formatDateOnly(workerData?.hireDate)}
                  </CustomText>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                      textAlign: "left",
                    }}
                  >
                    {t("workerDetails.shift")}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "left",
                    }}
                  >
                    {workerData?.shiftSchedule || "--"}
                  </CustomText>
                </Box>
              </Box>
            </Box>
          </Box>
          {/* Account Details */}
          {/* Chart */}
          <Box>
            {/* <ActiveInactiveChart /> */}
            {/* <DetailsMapSection workerId={worker.id} /> */}
          </Box>
        </Box>

        {/* Right Column */}
        <Box
          sx={{
            width: isMobile ? "100%" : "50%",
            borderRadius: 2,
            p: 3,
            border: "1px solid #E4E6EF",
          }}
        >
          <Box>

            {/* Work Location Details */}
            <Box sx={{ mt: 3, mb: 3 }}>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 600,
                  color: "#000000",
                  textAlign: "left",
                }}
              >
              {t("workerDetails.workLocationDetails")}
              </CustomText>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
              {t("workerDetails.country")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
             {workerData?.address.country}
              </CustomText>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
               {t("workerDetails.communityProvince")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
{workerData?.address.province}              </CustomText>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
               {t("workerDetails.city")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
              {workerData?.address.city}
              </CustomText>
            </Box>

            {/* Activity Details */}
            <Box sx={{ mt: 3, mb: 3 }}>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 600,
                  color: "#000000",
                  textAlign: "left",
                }}
              >
            {/* {t("workerDetails.activityDetails")} */}
        {t("scheduleDetails")} 
              </CustomText>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                }}
              >
         {/* {t("workerDetails.requests")} */}
   {t("startTime")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                }}
              >
               {/* {workerData?.attendanceSettings.schedule.startTime} */}
               {formattedStartTime}
              </CustomText>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                }}
              >
   {t("endTime")}             </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                }}
              >
               {formattedEndTime}

              </CustomText>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                }}
              >
       {t("graceTime")}            </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                }}
              >
{workerData?.attendanceSettings?.schedule?.graceMinutes || "--"} min

              </CustomText>
            </Box>

            {/* Break Time */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                }}
              >
                {t("editModal.labels.breakMinutes") || "Break Time"}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                }}
              >
                {workerData?.attendanceSettings?.schedule?.breakPolicy?.unpaid || "--"} min
              </CustomText>
            </Box>

            {/* Daily Hours / Work Hours */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                }}
              >
                {t("workHours") || "Work Hours"}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                }}
              >
                {formatDailyHoursDisplay(
                  workerData?.attendanceSettings?.schedule?.dailyHours ?? workerData?.workHours
                )}
              </CustomText>
            </Box>

            
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
              {t("salary")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
             {workerData?.salary || "--"}
              </CustomText>
            </Box>

            {/* Working Days */}
            <Box
              sx={{
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  mb: 1,
                  textAlign:"left"
                }}
              >
                {t("editModal.labels.workingDays") || "Working Days"}
              </CustomText>
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                {workerData?.attendanceSettings?.schedule?.workingDays && workerData.attendanceSettings.schedule.workingDays.length > 0 ? (
                  workerData.attendanceSettings.schedule.workingDays.map((day) => (
                    <Box
                      key={day}
                      sx={{
                        minWidth: 40,
                        height: 32,
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: 600,
                        bgcolor: "#1976d2",
                        color: "#fff",
                        fontFamily: "Poppins, sans-serif",
                        px: 1,
                      }}
                    >
                      {day}
                    </Box>
                  ))
                ) : (
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 14,
                      fontWeight: 400,
                      color: "#999",
                      fontStyle: "italic",
                    }}
                  >
                    {t("noWorkingDays") || "No working days set"}
                  </CustomText>
                )}
              </Box>
            </Box>

            {/* Schedule Location Map */}
            {workerData?.attendanceSettings?.workLocation?.latitude && 
             workerData?.attendanceSettings?.workLocation?.longitude && (
              <Box sx={{ mb: 2, mt: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" ,mb:2}}  >
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontSize: 16,
                    fontWeight: 400,
                    color: "#5E5C5C",
                    mb: 1.5,
                    textAlign:"left"
                  }}
                >
                  {t("editModal.map.location") || "Location"}
                </CustomText>
                {workerData.attendanceSettings.workLocation.locationName && (
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 14,
                      fontWeight: 400,
                      color: "#172B4D",
                      mt: 1,
                    }}
                  >
                    {workerData.attendanceSettings.workLocation.locationName}
                  </CustomText>
                )}
                </Box>
                <Box
                  sx={{
                    height: 300,
                    borderRadius: "8px",
                    overflow: "hidden",
                    border: "1px solid #E4E6EF",
                  }}
                >
                  <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    center={{
                      lat: parseFloat(workerData.attendanceSettings.workLocation.latitude),
                      lng: parseFloat(workerData.attendanceSettings.workLocation.longitude),
                    }}
                    zoom={15}
                    options={{
                      fullscreenControl: false,
                      mapTypeControl: false,
                      streetViewControl: false,
                    }}
                  >
                    <Marker
                      position={{
                        lat: parseFloat(workerData.attendanceSettings.workLocation.latitude),
                        lng: parseFloat(workerData.attendanceSettings.workLocation.longitude),
                      }}
                      icon={getBlueMarkerIcon()}
                      onClick={() => setActiveMapPopup("schedule")}
                    />
                    {activeMapPopup === "schedule" && (
                      <InfoWindow
                        position={{
                          lat: parseFloat(workerData.attendanceSettings.workLocation.latitude),
                          lng: parseFloat(workerData.attendanceSettings.workLocation.longitude),
                        }}
                        onCloseClick={() => setActiveMapPopup(null)}
                      >
                        <Box sx={{ fontFamily: "Poppins, sans-serif" }}>
                          {workerData.attendanceSettings.workLocation.locationName || "Work Location"}
                        </Box>
                      </InfoWindow>
                    )}
                    {workerData.attendanceSettings.workLocation.radiusMeters && (
                      <Circle
                        center={{
                          lat: parseFloat(workerData.attendanceSettings.workLocation.latitude),
                          lng: parseFloat(workerData.attendanceSettings.workLocation.longitude),
                        }}
                        radius={Number(workerData.attendanceSettings.workLocation.radiusMeters) || 100}
                        options={{
                          strokeColor: "#1976d2",
                          strokeOpacity: 1,
                          strokeWeight: 1,
                          fillColor: "#1976d2",
                          fillOpacity: 0.1,
                        }}
                      />
                    )}
                  </GoogleMap>
                </Box>
           
              </Box>
            )}

          </Box>
        </Box>
      </Box>
       <Box sx={{
         border: "2px solid #091E4224",backgroundColor:"white",borderRadius:2,mt:1,ml:1,mr:1,mb:1,px:2,
       }}>
       <Tabs value={value} onChange={handleChange} aria-label="worker tabs" 
         sx={{
    mb: 1,
    minHeight: 36,
    "& .MuiTabs-indicator": { backgroundColor: "#006EC2", height: "3px", borderRadius: 2 },
  }}>
        <Tab label= {t("attendance")}  sx={{
           fontSize: "15px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    textTransform: "none",
    color: "#44546F",
    minHeight: "unset",
    padding: "6px 12px",
    paddingBottom: "4px",
    mt: 1,}}/>
        <Tab label= {t("tasks")} sx={{ fontSize: "15px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    textTransform: "none",
    color: "#44546F",
    minHeight: "unset",
    padding: "6px 12px",
    paddingBottom: "4px",
    mt: 1,}}/>

   
        <Tab label={t("requests")}  sx={{
           fontSize: "15px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    textTransform: "none",
    color: "#44546F",
    minHeight: "unset",
    padding: "6px 12px",
    paddingBottom: "4px",
    mt: 1,}}/>
        <Tab label=  {t("documents")} sx={{
           fontSize: "15px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    textTransform: "none",
    color: "#44546F",
    minHeight: "unset",
    padding: "6px 12px",
    paddingBottom: "4px",
    mt: 1,}}/>
    <Tab label=  {t("payrolls")} sx={{
           fontSize: "15px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    textTransform: "none",
    color: "#44546F",
    minHeight: "unset",
    padding: "6px 12px",
    paddingBottom: "4px",
    mt: 1,}}/>
       <Tab label= {t("reimbursements")} sx={{ fontSize: "15px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    textTransform: "none",
    color: "#44546F",
    minHeight: "unset",
    padding: "6px 12px",
    paddingBottom: "4px",
    mt: 1,}}/>
     <Tab label= {t("absences")} sx={{ fontSize: "15px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    textTransform: "none",
    color: "#44546F",
    minHeight: "unset",
    padding: "6px 12px",
    paddingBottom: "4px",
    mt: 1,}}/>
     <Tab label= {t("report")} sx={{ fontSize: "15px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    textTransform: "none",
    color: "#44546F",
    minHeight: "unset",
    padding: "6px 12px",
    paddingBottom: "4px",
    mt: 1,}}/>
      </Tabs>
            </Box>
            {value === 0 && <WorkerAttendance workerId={worker.id} />}
              {value === 1&& <WorkerTask workerId={worker.id} />}
   {value === 2&& <WorkerRequest workerId={worker.id} />}
      {value === 3&& <WorkerDocument workerId={worker.id} />}
           {value === 4&& <WorkerExpense workerId={worker.id} />}
           {value === 5&& <WorkerReimbursements workerId={worker.id} />}
             {value === 6&& <WorkerAbsence workerId={worker.id} />}
             {value === 7&& <WorkerReports workerId={worker.id} />}
        {/* <AttendanceRecordsTable /> */}
        {/* <WorkerAttendance workerId={worker.id} /> */}

    </>
  );
};

export default WorkerDetails;
